
export default function currentProjectIDReducer(currentProjectID, action) {
  switch (action.type) {
    case 'RECEIVED_PROJECT':
      if (action?.tempId === currentProjectID) {
        return action.project.id;
      }

      return currentProjectID;
    case 'MARK_PROJECT_DELETED':
      if (currentProjectID != action.projectId) return currentProjectID;
      action.id = null;
    case 'UNSET_CURRENT_PROJECT':
    case 'SET_CURRENT_PROJECT':
      return action.id;
    default:
      return currentProjectID;
  }
}
